import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '1rem 1rem 0 0',
    borderBottom: '0.0625rem solid #F1F1F1',
    boxSizing: 'border-box',
    // @ts-expect-error Prop exists
    padding: ({ isDirect }) =>
      isDirect ? '0.75rem 1.5rem 0.75rem 0.75rem' : '0.75rem 1.5rem',
    maxHeight: '61px',
    height: '100%',
    // @ts-expect-error Prop exists
    justifyContent: ({ isDirect, centerContent }) =>
      centerContent || isDirect ? 'space-between' : 'inherit',
    // @ts-expect-error Prop exists
    backgroundColor: ({ verified }) =>
      verified ? 'white' : 'rgb(255, 237, 237)'
  },

  empty: {
    height: '100%'
  },

  section: {
    display: 'flex',
    alignItems: 'center'
  },

  name: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    maxWidth: '30rem',
    fontSize: theme.size.sm,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: '#323436'
  },

  nameSection: {
    width: '100%'
  }
}))

export default useStyles
